import {Component, computed, inject} from '@angular/core';
import {TableModule} from 'primeng/table';
import {Menu} from 'primeng/menu';
import {TranslatePipe} from '@ngx-translate/core';
import {CurrencyPipe, DatePipe} from '@angular/common';
import {ElciaButton} from '../../../../components/buttons/button/button';
import {
  PeriodNavigatorComponent,
  PeriodRange,
  PeriodType
} from '../../../../components/period-navigator/period-navigator';
import {FinancesPeriodStore} from '../../services/finances-period.store';
import {AccountingExportStore} from '../../services/accounting-export-store';

interface ExportMenuItem {
  value: 'preview' | 'export';
  label: string;
  icon: string;
}

@Component({
  selector: 'elcia-accounting-export-summary',
  imports: [TableModule, Menu, TranslatePipe, DatePipe, CurrencyPipe, ElciaButton, PeriodNavigatorComponent],
  providers: [AccountingExportStore],
  templateUrl: './accounting-export-summary.html',
  styleUrl: './accounting-export-summary.scss',
})
export class AccountingExportSummary {
  protected periodStore = inject(FinancesPeriodStore);
  protected store = inject(AccountingExportStore);

  protected readonly PeriodType = PeriodType;

  protected readonly isExporting = computed(() =>
    this.store.previewMutation.isPending() || this.store.exportMutation.isPending()
  );

  protected readonly menuItems: ExportMenuItem[] = [
    {value: 'preview', label: 'accounting-export.preview', icon: 'pi-file-export'},
    {value: 'export', label: 'accounting-export.export', icon: 'pi-calculator'},
  ];

  protected setPeriod($event: PeriodRange) {
    this.periodStore.period.set($event);
  }

  protected run(value: ExportMenuItem['value']) {
    if (this.store.rows().length === 0) return;
    if (value === 'preview') {
      this.store.previewMutation.mutate();
    } else {
      this.store.exportMutation.mutate();
    }
  }
}
